import { infoPedimentoGet } from "../../../api/pedimento";
import { getTipoOperacionDescripcion } from "../../../common/pedimentos/utils";
import { dateFilterExportacionSelectChoices, dateFilterImportacionSelectChoices } from "../choices";
import { getMaterialPadreEnDescarga } from "../common";
import { dataTableListaMateriales } from "../dataTables/DataTableListaMateriales";
import { dataTableDescarga, dataTableDetalle, dataTablePedimentos, freezeAllDataTables } from "../dataTables/index";
import { DescargaCommonGlobal } from "../descarga.global";
import { headerDetalleDataTable } from "./dataTableDetallePedimento";
import { headerPedimentoDataTable } from "./dataTablePedimento";
import {
    btnBuscarPedimentos,
    btnCancelaDescargo,
    btnDescarga,
    btnSiguienteMaterial,
    inputDatePicker,
} from "./headerView";
import {
    modalListaMaterialesCantidadRequeridaElement,
    modalListaMaterialesFechaInicialElement,
    modalListaMaterialesMaterialElement,
} from "./modalListaMateriales";

/**
 * Deshabilita o habilita los componentes para la busqueda de pedimentos
 */
export const disabledBusquedaPedimentos = (disable = true) => {
    inputDatePicker.disabled = disable;
    btnBuscarPedimentos.disabled = disable;
    if (disable) {
        dateFilterImportacionSelectChoices.disable();
        dateFilterExportacionSelectChoices.disable();
    } else {
        dateFilterImportacionSelectChoices.enable();
        dateFilterExportacionSelectChoices.enable();
    }
};

/**
 * Restablece los componentes de la vista
 */
export const resetView = (unfreezeTables = false) => {
    DescargaCommonGlobal.enProceso = false;

    headerPedimentoDataTable.innerHTML = "";
    headerPedimentoDataTable.previousElementSibling.innerHTML = "Pedimentos de exportación";

    headerDetalleDataTable.innerHTML = "";
    headerDetalleDataTable.previousElementSibling.innerHTML = "Detalles del pedimento";

    btnDescarga.disabled = true;
    btnDescarga.innerHTML = "Iniciar proceso de descarga";

    btnSiguienteMaterial.disabled = true;
    btnSiguienteMaterial.classList.add("d-none");

    btnCancelaDescargo.disabled = true;
    btnCancelaDescargo.classList.add("d-none");

    DescargaCommonGlobal.pedimentosExportacionValidos = {};
    DescargaCommonGlobal.contenedoresImportacionParaDescargar = [];
    DescargaCommonGlobal.contenedoresImportacionValidadosParaDescarga = [];

    dataTablePedimentos.options.data = [];
    dataTableDetalle.options.data = [];
    dataTableDescarga.options.data = [];

    dataTablePedimentos.rowmanager.checkAll(false);
    dataTableDetalle.rowmanager.checkAll(false);
    dataTableDescarga.rowmanager.checkAll(false);

    dataTableDetalle.options.noDataMessage = "Sin mercancías disponibles";

    if (unfreezeTables) freezeAllDataTables(false);

    dataTableDescarga.refresh();
    dataTablePedimentos.refresh();
    dataTableDetalle.refresh();

    disabledBusquedaPedimentos(false);
};

/**
 * Muestra en pantalla la lista de materiales del recorrido
 */
export const handleMostrarListaMateriales = () => {
    dataTableListaMateriales.options.data = [];
    dataTableListaMateriales.refresh();

    const materialPadre = getMaterialPadreEnDescarga();

    if (!materialPadre.listaMateriales) return;

    modalListaMaterialesMaterialElement.innerText = materialPadre.material;
    modalListaMaterialesCantidadRequeridaElement.innerText = materialPadre.cantidadPorDescargar;
    modalListaMaterialesFechaInicialElement.innerText = materialPadre.listaMateriales.fecha_inicio;

    const { detalles } = materialPadre.listaMateriales;

    dataTableListaMateriales.options.data = detalles.map((itm) => ({
        materialHijo: itm.material_hijo,
        cantidadUtilizada: itm.cantidad_utilizada,
        cantidadPorDescargar: itm.cantidadPorDescargar,
        porcentaje_desperdicio: itm.porcentaje_desperdicio,
        porcentaje_merma: itm.porcentaje_merma,
    }));

    dataTableListaMateriales.refresh();

    $("#modal-lista-materiales").modal("show");
};

/**
 * Mostrar información detallada de un pedimento
 * @param {number} pedimentoId
 */
export const handleMostrarInformacionPedimento = async (pedimentoId) => {
    const modalPedimento = document.getElementById("modalBody-pedimento");
    modalPedimento.style.display = "block";

    const modalLista = document.getElementById("modalBody-lista");
    modalLista.style.display = "none";

    const titulo = document.getElementById("modalHeader");
    titulo.innerText = "Información del pedimento";

    const numeroPedimentoElement = document.getElementById("modal-pedimento-numero-value");
    const tipoOperacionElement = document.getElementById("modal-pedimento-tipo-value");
    const fechaPagoRealElement = document.getElementById("modal-pedimento-fecha-value");
    const tipoCambioElement = document.getElementById("modal-pedimento-tipo-cambio-value");
    const patenteElement = document.getElementById("modal-pedimento-patente-value");
    const seccionAduaneraElement = document.getElementById("modal-pedimento-seccion-value");
    const claveDocumentoElement = document.getElementById("modal-pedimento-clave-doc-value");

    numeroPedimentoElement.innerHTML = "";
    tipoOperacionElement.innerHTML = "";
    fechaPagoRealElement.innerHTML = "";
    tipoCambioElement.innerHTML = "";
    patenteElement.innerHTML = "";
    seccionAduaneraElement.innerHTML = "";
    claveDocumentoElement.innerHTML = "";

    const informacionPedimento = await infoPedimentoGet(pedimentoId);

    if (informacionPedimento && informacionPedimento.length > 0) {
        const pedimento = informacionPedimento[0];

        const tipoOperacionDescripcion = getTipoOperacionDescripcion(pedimento.tipo_operacion);

        numeroPedimentoElement.innerHTML = pedimento.numero_pedimento;
        tipoOperacionElement.innerHTML = tipoOperacionDescripcion?.descripcion;
        fechaPagoRealElement.innerHTML = pedimento.fecha_pago_real;
        tipoCambioElement.innerHTML = pedimento.tipo_cambio || "-";
        patenteElement.innerHTML = pedimento.patente || "-";
        seccionAduaneraElement.innerHTML = pedimento.seccion_aduanera_clave || "-";
        claveDocumentoElement.innerHTML = pedimento.clave_documento_clave || "-";
    }
};
